import request from 'utils/request'

const fetchCountries = (options = {}) => request('countries/', { ...options })
const fetchAdmins = (options = {}) => request('admin/admins', { ...options })
const updateAdmin = (id, options = {}) =>
  request(`admin/admins/${id}`, { method: 'PUT', ...options })
const fetchCountry = (id, options = {}) => request(`countries/${id}`, { ...options })
const deleteMedia = (id, options = {}) =>
  request(`admin/media/${id}`, { method: 'DELETE', ...options })

export { fetchCountry, fetchCountries, fetchAdmins, updateAdmin, deleteMedia }
